export default "__VITE_ASSET__BpaOJJjg__"